import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CalendarModule, InputTextModule, RadioButtonModule } from 'primeng/primeng';
import { CadensSharedModule } from '../shared';

import {
    Register,
    Activate,
    Password,
    PasswordResetInit,
    PasswordResetFinish,
    SessionsService,
    SessionsComponent,
    PasswordStrengthBarComponent,
    RegisterComponent,
    RegisterConfirmationComponent,
    ActivateComponent,
    PasswordComponent,
    PasswordResetInitComponent,
    PasswordResetFinishComponent,
    SettingsComponent,
    LoginService,
    JhiLoginComponent,
    accountState
} from './';

@NgModule({
    imports: [
        CadensSharedModule,
        RouterModule.forRoot(accountState, { useHash: true }),
        CalendarModule,
        InputTextModule,
        RadioButtonModule
    ],
    declarations: [
        ActivateComponent,
        RegisterComponent,
        RegisterConfirmationComponent,
        PasswordComponent,
        PasswordStrengthBarComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        SessionsComponent,
        SettingsComponent,
        JhiLoginComponent
    ],
    providers: [
        SessionsService,
        Register,
        LoginService,
        Activate,
        Password,
        PasswordResetInit,
        PasswordResetFinish
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensAccountModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/account.module.ts